(() => {
  "use strict";

  const slugify = (value) => value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "section";

  const enhanceArticle = (article) => {
    const content = article.querySelector("[data-bw-content]");
    if (!content) return;

    const headings = [...content.querySelectorAll("h2")];
    const usedIds = new Set([...article.querySelectorAll("[id]")].map((node) => node.id));

    headings.forEach((heading, index) => {
      if (heading.id) return;
      const base = slugify(heading.textContent.trim());
      let candidate = base;
      let suffix = 2;
      while (usedIds.has(candidate)) {
        candidate = `${base}-${suffix}`;
        suffix += 1;
      }
      heading.id = candidate || `section-${index + 1}`;
      usedIds.add(heading.id);
    });

    const toc = article.querySelector("[data-bw-toc]");
    const tocList = article.querySelector("[data-bw-toc-list]");
    const tocCount = article.querySelector("[data-bw-toc-count]");

    if (toc && tocList && headings.length > 1) {
      const fragment = document.createDocumentFragment();
      headings.forEach((heading) => {
        const item = document.createElement("li");
        const link = document.createElement("a");
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        fragment.appendChild(item);
      });
      tocList.appendChild(fragment);
      if (tocCount) tocCount.textContent = `${headings.length} sections`;
      toc.hidden = false;
    }

    const skip = article.querySelector("[data-bw-skip]");
    if (skip && headings[0]) skip.href = `#${headings[0].id}`;

    content.querySelectorAll("table").forEach((table) => {
      if (table.parentElement?.classList.contains("bw-table-wrap") || table.closest(".table-wrap")) return;
      const wrap = document.createElement("div");
      wrap.className = "bw-table-wrap";
      wrap.setAttribute("role", "region");
      wrap.setAttribute("aria-label", "Scrollable comparison table");
      wrap.tabIndex = 0;
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    content.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute("rel") || "").split(/\s+/).filter(Boolean));
      rel.add("noopener");
      rel.add("noreferrer");
      link.setAttribute("rel", [...rel].join(" "));
    });

    const progress = article.querySelector("[data-bw-progress]");
    const backToTop = article.querySelector("[data-bw-back-to-top]");
    let ticking = false;

    const updateScrollUi = () => {
      const rect = article.getBoundingClientRect();
      const total = Math.max(article.offsetHeight - window.innerHeight, 1);
      const travelled = Math.min(Math.max(-rect.top, 0), total);
      const ratio = travelled / total;
      if (progress) progress.style.transform = `scaleX(${ratio})`;
      if (backToTop) backToTop.hidden = ratio < 0.18;
      ticking = false;
    };

    window.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollUi);
    }, { passive: true });

    backToTop?.addEventListener("click", () => {
      article.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    updateScrollUi();
    article.dataset.bwEnhanced = "true";
  };

  document.querySelectorAll("[data-bw-article]").forEach(enhanceArticle);
})();
